import { FC } from "react"
import { HeaderLogo } from '@sainsburys-tech/luna-header';
import './index.scss';
import key from '../../Assets/key/key.svg'

const Unauthorised: FC = () => {

    return <>

        <HeaderLogo>
            <p className="header-item__link logo-font-size" style={{ position: "absolute", left: "20px" }}>Origin Pick</p>
        </HeaderLogo>

        <div className="ln-u-text-align-center ln-u-soft ln-c-button--full">
            <img src={key} alt="key" style={{ width: '120px', marginBottom:'15px' }} />
            <h1 className="text" style={{fontSize:'20px',marginBottom:'15px'}}>Access is denied</h1>
            <p className="text" style={{fontSize:'16px', marginBottom:'0px'}}>You are not authorised to access this application</p>
            <p className="text" style={{fontSize:'16px'}}>Please contact your system administrator for more information</p>
        </div>

        {/* <div className="ln-u-text-align-center ln-u-soft ln-u-bg-color-grey-light">
            <Locked /><b>Access Denied</b>. You are not authorised to access this application
            style={{width:'120px',position:"absolute", left:"600px", top:"50px"}}
            style={{position:"absolute", left:"500px", top:"200px"}}
        </div> */}
    </>
}
export default Unauthorised